export default __webpack_public_path__ + "9adc3abb6aadf76004c8523d2da9946e.png";